import React from 'react';
import TreatmentConsentLandingPage from './TreatmentConsentLandingPage';

export default function SedationConsentFormUk() {
  return (
    <TreatmentConsentLandingPage
      title="Sedation Consent Form UK | Dental Sedation Consent | Smile Consent"
      description="Build a sedation consent form for UK dental practices with AI-assisted drafting, digital signing, and clearer records for fasting, escort requirements, risks, and recovery."
      canonicalUrl="https://smileconsent.co.uk/sedation-consent-form-uk"
      h1="Sedation Consent Form for UK Practices"
      treatmentName="Sedation consent form"
      intro="Create sedation consent forms with clearer records for suitability, escort requirements, fasting advice, recovery expectations, and digital signing for UK dental teams."
      risks={[
        'The reason sedation is proposed, expected benefits, and the difference between sedation and general anaesthesia.',
        'Material risks such as oversedation, nausea, vomiting, bruising, prolonged drowsiness, and rare adverse reactions.',
        'Escort arrangements, transport home, fitness for discharge, and restrictions on driving, work, or decision-making afterward.',
        'Pre-operative requirements including fasting instructions, medication review, medical history, and suitability assessment.',
        'Alternatives such as local anaesthetic alone, behavioural support, staged treatment, or referral where appropriate.',
      ]}
      relatedLinks={[
        { title: 'Wisdom tooth consent form UK', description: 'Common surgical consent page linked to sedation cases', path: '/wisdom-tooth-consent-form-uk' },
        { title: 'Tooth extraction consent form UK', description: 'Consent wording for routine and surgical extraction', path: '/tooth-extraction-consent-form-uk' },
        { title: 'AI dental consent forms', description: 'See all treatment-specific consent workflows', path: '/dental-consent-forms' },
      ]}
    />
  );
}
